import { useEffect, useState } from 'react';
import { useTheme } from '../context/ThemeContext';

const read = (name) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim();

const build = () => {
  const hsl = (name) => {
    const channels = read(name);
    return channels ? `hsl(${channels})` : undefined;
  };
  return {
    series: [1, 2, 3, 4, 5, 6, 7, 8].map((i) => hsl(`--chart-${i}`)),
    grid: hsl('--chart-grid'),
    axis: hsl('--chart-axis'),
    surface: hsl('--bg-surface-raised'),
    border: hsl('--border-default'),
    text: hsl('--text-primary'),
  };
};

/**
 * Chart colours resolved from the theme tokens at render time. Re-computed
 * whenever the resolved theme flips, so charts recolour without a reload.
 */
export function useChartTheme() {
  const { resolved } = useTheme();
  const [palette, setPalette] = useState(build);

  useEffect(() => {
    // One frame after the attribute flip so the new variables are in effect.
    const id = requestAnimationFrame(() => setPalette(build()));
    return () => cancelAnimationFrame(id);
  }, [resolved]);

  return palette;
}
